import React from "react"
import styled from "styled-components"
import "./index.scss"
import { Search } from "@material-ui/icons"
import { navigate } from "gatsby"
import { useTranslation } from "react-i18next"

const Container = styled.div`
  margin: 39px 35px 20px 35px;
  .headline {
    font-weight: 700;
    font-size: 20px;
    color: #2a3795;
    margin-bottom: 15px;
  }

  @media screen and (max-width: 415px) {
    margin: 39px 30px 20px 30px;
  }
`

function ControlGroup(props) {
  const { categoryUrlList, locale, queryString, searchFaq, currentCatUrl } = props
  const { t } = useTranslation();

  return (
    <Container>
      <div className="headline">{t(`support_page_title`)}</div>
      <div className="supportPage__controls">
        <select
          className="supportPage__categorySelector"
          onChange={e => {
            console.log(e.target.value)
            navigate(e.target.value)
          }}
          value={currentCatUrl}
        >
          <option value={`/${locale}`} disabled="">
            {t("support_select_category")}
          </option>
          {categoryUrlList.map(o => {
            return <option value={o.url}>{o.name}</option>
          })}
        </select>
        <div className="supportPage__searchField">
          <input
            type="text"
            placeholder={t("support_search")}
            value={queryString}
            onChange={searchFaq}
          />
          <Search />
        </div>
      </div>
    </Container>
  )
}

export default ControlGroup
